module.exports = __webpack_public_path__ + "img/10-10.c56c4e98.png";